/** The app side of the system-browser login (2026-09-18): parse snugtale://auth/callback, redeem the
 * one-time code with the PKCE verifier, hand the tokens to AuthContext. Pure parsing is separate so it
 * can be unit-tested; `handled` guards against the same URL being delivered twice (cold start). */
export const AUTH_CALLBACK_HOST = 'auth';

export interface AuthCallbackParams { code: string | null; error: string | null; isNew: boolean; claimed: string | null; provider: string | null; }

export function isAuthCallbackUrl(url: string): boolean {
  try {
    const u = new URL(url);
    return u.protocol === 'snugtale:' && (u.host === AUTH_CALLBACK_HOST || u.pathname.startsWith('//auth')) && /\/callback\/?$/.test(u.pathname) || (u.protocol === 'snugtale:' && url.startsWith('snugtale://auth/callback'));
  } catch { return false; }
}

export function parseAuthCallback(url: string): AuthCallbackParams {
  const q = new URL(url).searchParams;
  return { code: q.get('code'), error: q.get('error'), isNew: q.get('new') === '1', claimed: q.get('claimed'), provider: q.get('provider') };
}

const handled = new Set<string>();
export function markHandled(url: string): boolean {
  if (handled.has(url)) return false;
  handled.add(url);
  return true;
}
export function _resetHandledForTests(): void { handled.clear(); }

/** The custom-scheme URL the interstitial hops to: only the whitelisted keys travel, nothing else. */
export function buildNativeCallbackUrl(params: URLSearchParams): string {
  const out = new URLSearchParams();
  for (const k of ['code', 'error', 'new', 'claimed', 'provider']) {
    const v = params.get(k);
    if (v && /^[A-Za-z0-9._~-]{1,200}$/.test(v)) out.set(k, v);
  }
  if (!out.has('code') && !out.has('error')) out.set('error', 'handoff_invalid');
  return `snugtale://auth/callback?${out.toString()}`;
}
